module.exports = __webpack_public_path__ + "static/part-time-user-avatar-icon-9ed14090033e8d6f4e94b4d49162a69c.svg";